<template>
  <div class="customer">
    <v-overlay :value="addressLookupLoading" z-index="999">
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        <div class="mt-4 white--text text-subtitle-1">{{ $t('message.customer.fetchingAddress') }}</div>
      </div>
    </v-overlay>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data v-else :references.sync="formReferences" :model="modelObj" ref="crmReference">
      <template slot="combo">
        <v-combobox :label="$t('message.customer.name')" hide-details outlined dense v-model="modelObj.name" :rules="$_requiredValidation" :loading="isLoading"
          :search-input.sync="search" @keypress="canDoSearch = true" item-text="valuewithOrg" item-value="value" :items="companyArray" @change="autoFillAddress">
        </v-combobox>
        <small v-if="isCustomerExists" class="error--text">{{ $t('message.customer.exists') }}</small>
      </template>
      <template slot="customerphone_slot">
        <country-phone-input :modelObj.sync="modelObj" numberProp="telephone1" dialCodeProp="phone_dialcode">
          <template v-slot:append>
            <v-btn v-if="!modelObj.id && !showLookupDialog" class="my-1" x-small @click="getContactByPhone" color="primary" :disabled="disableLookupButton">
              {{ !showLookupDialog ? '1881 Lookup' : '' }}
            </v-btn>
          </template>
        </country-phone-input>
      </template>
      <template slot="extraDetails" v-if="modelObj.id">
        <label class="pa-2" v-if="modelObj.sharepoint_link">{{ $t('message.onedriveSettings.odLink') }}: <a  target="_blank" :href="modelObj.sharepoint_link">{{ modelObj.sharepoint_link }}</a></label>
        <div v-if="modelObj.createdon || modelObj.updatedon">
          <label class="pa-2 d-block" v-if="modelObj.createdon">{{ $t('message.customer.createdOn') }}: {{ $formatter.formatDate(modelObj.createdon, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm') }}</label>
          <label class="pa-2 d-block" v-if="modelObj.updatedon">{{ $t('message.customer.updatedOn') }}: {{ $formatter.formatDate(modelObj.updatedon, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm') }}</label>
        </div>
      </template>
      <template slot="share_report">
        <v-btn color="info" class="ml-3" @click="exportPriceList" :loading="exporting" v-if="modelObj.id" dark>
          {{ $t('message.customer.priceList') }}
        </v-btn>
      </template>
    </form-data>
    <v-dialog v-model="showLookupDialog" fullscreen persistent transition="dialog-bottom-transition">
      <v-card tile>
        <v-toolbar  dark color="primary">
          <v-toolbar-title>{{ $t('message.contact.contactLookupHeader') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showLookupDialog = false" id="contact_close_btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-simple-table dense class="bordered--table customer-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th v-for="(header, index) in lookupAddress" :key="index">{{ header }}</th>
                  </tr>
                </thead>
                <tbody v-for="(item, index) in listOfContactsFromlookup" :key="index">
                  <tr>
                    <td width="2%">
                      <v-checkbox hide-details class="mt-0" :key="index" v-model="item.includes" @change="checkAllIsTrue(index)"></v-checkbox>
                    </td>
                    <td>
                      {{item.name}}
                      <template  v-if="item.namealreadyexists" class="pl-2">
                        (<v-icon color="warning" class="pr-2">mdi-alert</v-icon>
                        <span>{{ $t('message.contact.nameExists') }}</span>)
                      </template>
                    </td>
                    <td>{{item.type}}</td>
                    <td>{{item.organizationnumber}}</td>
                    <td>{{ item.geography ? item.geography.municipality : '' }}</td>
                    <td>{{ item.geography ? item.geography.county : '' }}</td>
                    <td>{{ item.geography && item.geography.address ? item.geography.address.addressstring : '' }}</td>
                  </tr>
                  <!-- <tr v-if="item.includes">
                    <td colspan="7" class="white">
                      <form-data :references.sync="expansionFormReference" :model="contacts1881LookUpClone[index]" :key="`LookupContact-${ index }-${ reInit }`" ref="contactItemRef">
                        <template slot="combo">
                          <v-text-field hide-details :label="$t('message.customer.name')"
                            outlined dense v-model="contacts1881LookUpClone[index].name"></v-text-field>
                        </template>
                      </form-data>
                    </td>
                  </tr> -->
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-center">
            <v-btn color="primary" @click="checkForDuplicates" :disabled="checkAllIsTrue()" :loading="loading" class="mr-3">{{$t('message.common.save')}}</v-btn>
            <v-btn color="error" @click="showLookupDialog = false, disableLookupButton = false">{{$t('message.common.close')}}</v-btn><!-- , closeDialog() -->
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Check if the customer is used on any one of the open orders/offers -->
    <v-dialog v-model="orderUsedObj.dialog" persistent width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t('message.common.warning') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <h2 class="mt-3">{{ $t('message.orders.customerDataChanged') }}</h2>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="orderUsedObj.loading" @click="orderUsedObj.onSuccess()">{{ $t('message.common.yes') }} </v-btn>
          <v-btn color="error" @click="orderUsedObj.onCancel()">{{ $t('message.common.no') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '../../components/FormTemplate'
import Customer from '../../mixins/Customer/index'
import countries from '@/assets/json/countries.json'
import axios from 'axios'
export default {
  data () {
    return {
      countries: countries,
      modelObj: {
        id: this.$route.params.crm_id,
        isactive: true,
        iscustomer: false,
        issupplier: false,
        language: 'no',
        paymentmethod1: 'direct',
        vatid: 25,
        state: 2,
        name: '',
        invoicecurrencyid: 3,
        phone_dialcode: '+47'
      },
      listOfContactsFromlookup: [],
      contacts1881LookUpClone: [],
      contacts1881DetailedList: [],
      showLookupDialog: false,
      disableLookupButton: false,
      reInit: 0,
      fieldsLoading: false,
      loading: false,
      MODULE_URL: 'customers',
      addonsLoading: false,
      listOfCurrencyList: [],
      listOfVAT: [{
        text: '0%',
        value: 0
      }, {
        text: '25%',
        value: 25
      }],
      vatLoading: false,
      listOfPaymentType: [
        { id: 1, text: this.$t('message.invoice.saveAndEmail') }
      ],
      modelBack: {},
      exporting: false,
      isLoading: false,
      companyArray: [],
      search: '',
      isCustomerExists: false,
      canDoSearch: false,
      addressLookupLoading: false,
      orderUsedObj: {
        dialog: false
      },
      customerVisitAddressFrom1881: {}
    }
  },
  components: {
    'form-data': FormTemplate,
    'country-phone-input': () => import('@/components/CountryPhoneInputField')
  },
  mixins: [Customer],
  computed: {
    ...mapState(['FORM_TYPE', 'listOfCustomerPriorities', 'listofCustomerIndustries', 'listofCustomerShipments', 'listOfPaymentTerms', 'listOfDeliveryTerms']),
    customerSupplierSelection () {
      return [val => (!!this.modelObj.issupplier || !!this.modelObj.iscustomer) || 'Required']
    },
    formReferences () {
      return {
        title: this.$route.params.crm_id ? '' : this.$t('message.customer.addCustomer'),
        properties: [{
          type: this.FORM_TYPE.COMBOBOX,
          class: 'lg3 sm9',
          iscustomer: true
        },
        // {
        //   model: 'name',
        //   type: this.FORM_TYPE.TEXT,
        //   rules: this.$_requiredValidation,
        //   label: this.$t('message.customer.name'),
        //   class: 'lg3 sm6',
        //   change: this.changesMade
        // },
        {
          model: 'vat',
          type: this.FORM_TYPE.TEXT,
          rules: this.modelObj.issupplier ? [] : this.$_maxCharValidation(15),
          label: this.$t('message.customer.vat'),
          class: 'lg3 sm3',
          change: this.getPaymentMethod
        }, {
          model: 'email',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_multiEmailValidation,
          label: this.$t('message.customer.email'),
          class: 'lg3 md4 sm6',
          hint: this.$t('message.common.add_extra_mails'),
          persistent_hint: true,
          change: this.changesMade
        }, {
          model: 'invoiceemail',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_emailValidation,
          label: this.$t('message.customer.invoiceEmail'),
          class: 'lg3 md4 sm6',
          change: this.changesMade
        }, {
          model: 'homepage',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.customer.homepage'),
          class: 'lg3 md4 sm6',
          append_icon: 'mdi-link-variant',
          append_click: this.navigateToPage,
          change: this.changesMade
        },
        {
          type: this.FORM_TYPE.SLOT,
          slot: 'customerphone_slot',
          is_show: true,
          class: 'lg3 sm6'
        },
        // {
        //   model: 'telephone1',
        //   type: this.FORM_TYPE.TEXT,
        //   rules: [],
        //   label: this.$t('message.customer.phone'),
        //   class: 'lg2 md4 sm6',
        //   change: this.changesMade
        // },
        {
          model: 'language',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.login.language'),
          items: this.$_languagesList,
          select_text: 'title',
          select_value: 'value',
          class: 'lg2 md4 sm6',
          change: this.changesMade
        }, {
          model: 'location',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.deviations.location'),
          items: this.$_locations,
          select_text: 'text',
          select_value: 'value',
          class: 'lg2 md4 sm6',
          change: this.changesMade
        }, {
          model: 'priority',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfCustomerPriorities,
          term: 'priority',
          click: (term) => this.supportingList(this.CUSTOMER_PRIORITY, term),
          is_list: true,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 md4 sm6 xs12',
          label: this.$t('message.layout.discountGroup'),
          change: this.changesMade
        }, {
          model: 'vatid',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: `${this.$t('message.customer.vatValue')} %`,
          items: this.listOfVAT,
          select_text: 'text',
          select_value: 'value',
          class: 'lg1 md4 sm6',
          change: this.changesMade
        }, {
          model: 'industry',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listofCustomerIndustries,
          term: 'industry',
          click: (term) => this.supportingList(this.CUSTOMER_INDUSTRY, term),
          is_list: true,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 md4 sm6 xs12',
          label: this.$t('message.customer.industry'),
          change: this.changesMade
        }, {
          model: 'shipment',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listofCustomerShipments,
          term: 'shipment',
          click: (term) => this.supportingList(this.CUSTOMER_SHIPMENT, term),
          is_list: true,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 md4 sm6 xs12',
          label: this.$t('message.customer.shipment'),
          change: this.changesMade
        }, {
          model: 'state',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.customer.state'),
          items: this.$_listOfCustomerStates,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 md4 sm6',
          change: this.changesMade
        }, {
          model: 'paymentmethod1',
          type: this.FORM_TYPE.SELECT,
          rules: this.$_requiredValidation,
          label: `${this.$t('message.customer.paymentmethod')} 1`,
          items: this.paymentMethod1,
          select_text: 'text',
          select_value: 'value',
          class: 'lg2 md4 sm6',
          change: this.changesMade
        }, {
          model: 'paymentmethod2',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: [],
          label: `${this.$t('message.customer.paymentmethod')} 2`,
          items: this.listOfPaymentType,
          loading: this.vatLoading,
          select_text: 'text',
          select_value: 'id',
          class: 'lg2 md4 sm6',
          change: this.changesMade
        }, {
          model: 'paymentterm',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: [],
          label: `${this.$t('message.order.paymentTerm')}`,
          items: this.listOfPaymentTerms,
          term: 'paymentterm',
          click: (term) => this.supportingList(this.PAYMENTTERMS, term),
          is_list: true,
          select_text: 'name',
          select_value: 'days',
          class: 'lg2 md4 sm6',
          change: this.changesMade
        }, {
          model: 'invoicecurrencyid',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.product.currency'),
          items: this.listOfCurrencyList,
          select_text: 'name',
          select_value: 'id',
          class: 'lg1 md4 sm6',
          change: this.changesMade
        }, {
          model: 'deliveryterms_id',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: [],
          label: `${this.$t('message.order.deliveryTerm')}`,
          items: this.listOfDeliveryTerms,
          term: 'deliveryterms_id',
          click: (term) => this.supportingList(this.DELIVERYTERMS, term),
          is_list: true,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 md4 sm6',
          change: this.changesMade
        }, {
          model: 'custom_number',
          type: this.FORM_TYPE.TEXT,
          rules: this.modelObj.custom_number ? this.$_numberValidation : [],
          label: this.$t('message.customer.customerNumber'),
          class: 'lg2 md4 sm6',
          style: { display: this.modelObj.id ? 'block' : 'none' },
          disabled: true,
          change: this.changesMade
        }, /* {
          model: 'usebaseprice',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg3 sm4 my-auto',
          label: this.$t('message.customer.usebaseprices'),
          click: this.changesMade
        },  */{
          model: 'iscustomer',
          rules: this.customerSupplierSelection,
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg1 md4 sm4 my-auto',
          label: this.$t('message.customer.iscustomer'),
          disabled: !!this.modelObj.id,
          click: this.customerChanged
        }, {
          model: 'issupplier',
          rules: this.customerSupplierSelection,
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg2 sm4 my-auto',
          label: this.$t('message.customer.issupplier'),
          disabled: !!this.modelObj.id,
          click: this.supplierChanged
        }, {
          model: 'leadtime',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.product.leadTime'),
          class: 'lg2 sm2',
          style: { display: this.modelObj.issupplier ? 'block' : 'none' },
          change: this.changesMade
        }, {
          model: 'productionallowed',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg2 sm4 my-auto',
          label: this.$t('message.customer.productionAllowed'),
          change: this.changesMade
        }, {
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg2 md2 sm4 my-auto',
          label: this.$t('message.common.isActive'),
          change: this.changesMade
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.crm_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.confirmationForOrderCustomerUpdate(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'close_handler',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.confirmationForOrderCustomerUpdate(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.crm_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.push(`/${this.MODULE_URL}`),
          label: this.$t('message.common.backToList'),
          to: `/${this.MODULE_URL}`,
          is_show: true
        }, {
          name: 'delete_btn',
          color: 'error',
          label: this.$t('message.common.delete'),
          click: this.deleteHandler,
          is_show: this.$route.params.crm_id
        }]
      }
    },
    paymentMethod1 () {
      return [
        // { text: this.$t('message.customer.sg'), value: 'sg' },
        { text: this.$t('message.customer.direct'), value: 'direct' }
      ]
    },
    expansionFormReference () {
      return { properties: this.formReferences.properties.filter(x => x.slot !== 'customerphone_slot') }
    },
    lookupAddress () {
      return ['', this.$t('message.props.name'), this.$t('message.props.type'), this.$t('message.customer.organizationNumber'), this.$t('message.customer.municipality'), this.$t('message.customer.country'), this.$t('message.customer.address')]
    }
  },
  mounted () {
    this.debouncedGetSearchResults = this.$formatter.debounce(this.loadCompanyData, 600)
    this.getAllCurrencyList()
    if (this.modelObj.id) {
      this.getSingleRecordHandler()
    } else {
      this.modelObj.location = 'norwegian'
      this.countrySelected()
    }
    this.$store.dispatch('getCustomerPriority')
      .then((response) => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'priority', list: this.listOfCustomerPriorities })
        }
      })
    this.$store.dispatch('getCustomerIndustry')
      .then((response) => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'industry', list: this.listofCustomerIndustries })
        }
      })
    this.$store.dispatch('getCustomerShipment')
      .then((response) => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'shipment', list: this.listofCustomerShipments })
        }
      })
    this.$store.dispatch('getPaymentTerms', this.$t('message.common.days'))
      .then((response) => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'paymentterm', list: this.listOfPaymentTerms })
        }
      })
    this.$store.dispatch('getDeliveryTerms')
      .then((response) => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'deliveryterms_id', list: this.listOfDeliveryTerms })
        }
      })

    let text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.$router.push(`/${this.MODULE_URL}`)
      }
    })
    this.$eventBus.$on('setItemInField', (data) => {
      let model = Object.assign({ ...this.modelObj }, { [data.modelName]: data.recordId })
      this.modelObj = model
    })
  },
  watch: {
    'search' (val) {
      if (val === null || val.length <= 1) {
        const model = Object.assign({ ...this.modelObj }, { city: '', address: '', post: '' })
        this.modelObj = model
        this.companyArray = []
      } else if (this.canDoSearch && val != null && val.length >= 3) {
        // A half typed organization number only produces noise, wait until all 9 digits are entered
        if (this.isPartialOrganizationNumber(val)) return
        this.isLoading = true
        this.debouncedGetSearchResults()
      }
    }
  },
  methods: {
    getAllCurrencyList () {
      this.$_executeApi('get', 'currencies/get_all_currency_list')
        .then((response) => {
          response.data.sort((a, b) => a.name.localeCompare(b.name))
          this.listOfCurrencyList = response.data
        })
    },
    getPaymentMethod () {
      this.verfifyVat()
      this.changesMade()
      this.checkIfOrgNumberExists()
    },
    verfifyVat () {
      const organizationnumber = this.modelObj.vat
      if (organizationnumber) {
        this.vatLoading = true
        this.$_checkOrganzationExistsInElma(organizationnumber)
          .then((organizationExists) => {
            if (organizationExists) {
              this.listOfPaymentType.push({ id: 2, text: this.$t('message.invoice.saveAndUseEHF') })
            } else {
              var removeIndex = this.listOfPaymentType.findIndex(x => x.id === 2)
              if (removeIndex && removeIndex !== -1) this.listOfPaymentType.splice(removeIndex, 1)
            }
          })
          .finally(() => {
            this.vatLoading = false
          })
      }
    },
    setDefaultValues (data) {
      let { list, prop } = data
      let item = list.find(x => x.isdefault)
      if (item) {
        let model = Object.assign({ ...this.modelObj }, { [prop]: prop === 'paymentterm' ? item.days : item.id })
        this.modelObj = model
      }
    },
    getSingleRecordHandler () {
      this.fieldsLoading = true
      this.$_getSingleRecordHandler(`${this.MODULE_URL}/${this.modelObj.id}`)
        .then((result) => {
          if (result.data) {
            let payload = result.data
            payload.paymentmethod2 = +payload.paymentmethod2
            payload.paymentmethod1 = payload.paymentmethod1 ? payload.paymentmethod1.toLowerCase() : ''
            this.modelObj = payload
            this.modelBack = this.$formatter.cloneVariable(payload)
            if (this.modelObj.vat) this.verfifyVat()
            this.countrySelected()
          }
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    async confirmationForOrderCustomerUpdate (type) {
      if (this.$refs.crmReference.$refs.validateForm.validate()) {
        const { data: hasOpenOrder } = await this.hasOpenOrderWithCustomer()
        if (hasOpenOrder && this.$store.state.isChangesMade) {
          this.orderUsedObj = {
            dialog: true,
            onSuccess: () => {
              this.saveUpdateHandler(type, true)
            },
            onCancel: () => {
              this.saveUpdateHandler(type, false)
            }
          }
        } else {
          this.saveUpdateHandler(type, false)
        }
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    saveUpdateHandler (type, canUpdateOrder) {
      this.loading = true
      this.orderUsedObj.dialog = false
      let model = this.modelObj
      if (!model.leadtime) model.leadtime = null

      // Clean up email field - trim spaces and remove empty entries
      if (model.email) {
        model.email = model.email.split(',')
          .map(email => email.trim())
          .filter(email => email)
          .join(',')
      }

      let url = this.MODULE_URL
      let method = 'post'
      if (model.id) {
        url = `${url}/${model.id}?canUpdateOrder=${canUpdateOrder}`
        method = 'put'
      }
      let text = model.id ? this.$t('message.common.updatedSuccess') : this.$t('message.common.addedSucess')
      this.$_executeApi(method, url, model)
        .then(async (response) => {
          if (response.data) {
            this.$store.commit('isChangesMade', false)
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: text })
            // add address for the new customers if exists!
            if (!model.id && this.customerVisitAddressFrom1881 && this.customerVisitAddressFrom1881.address) {
              this.customerVisitAddressFrom1881.customer_id = response.data.id
              await this.saveCustomerAddress(this.customerVisitAddressFrom1881)
            }
            if (type === this.SAVE && !model.id) this.$router.push(`/${this.MODULE_URL}/edit/${response.data.id}/view`)
            else if (type === this.UPDATE_CLOSE) this.$router.push(`/${this.MODULE_URL}`)
            else this.getSingleRecordHandler()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    hasOpenOrderWithCustomer () {
      if (this.modelObj.id) {
        return this.$_executeApi('get', `customers/has_existing_order/${this.modelObj.id}`)
      } else {
        return Promise.resolve({ data: false })
      }
    },
    deleteHandler () {
      let ids = [this.modelObj.id]
      let payload = { ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
      this.$store.commit('showDeleteDialog', payload)
    },
    navigateToPage () {
      if (this.modelObj.homepage) {
        if (this.isValidHttpUrl(this.modelObj.homepage)) {
          window.open(`${this.modelObj.homepage}`, '_blank')
        } else window.open(`https://${this.modelObj.homepage}`, '_blank')
      }
    },
    // Fill Fields from company API
    async autoFillAddress () {
      if (typeof this.modelObj.name === 'object' && !Array.isArray(this.modelObj.name) && this.modelObj.name !== null) {
        this.modelObj.name = this.modelObj.name.value
      }
      this.canDoSearch = false
      this.customerVisitAddressFrom1881 = {}
      const getName = this.modelObj.name || ''
      if (this.companyArray.length > 0 && this.contacts1881DetailedList) {
        const contactObj = this.contacts1881DetailedList.find(x => x.name === getName && x.organizationnumber)
        if (contactObj) {
          this.modelObj.vat = contactObj.organizationnumber
          if (contactObj.id) {
            // make a call to get the address and add it to the customer!
            this.addressLookupLoading = true
            try {
              const { data: addressData } = await this.getAddressFrom1881(contactObj.id)
              // The detailed record carries the contact points, the search hit on its own does not
              const contactDetails = (addressData && addressData[0]) || contactObj
              // Not every unit has a registered address, brreg leaves it out entirely for some of them
              if (contactDetails.geography && contactDetails.geography.address) {
                const { street, housenumber, entrance, postcode, postarea } = contactDetails.geography.address
                let address = [street, housenumber, entrance].filter(x => x)
                if (address) address = address.join(' ')
                this.customerVisitAddressFrom1881 = { address, postcode, city: postarea, type: 'invoice' }
              }
              this.fillContactDetailsFromLookup(contactDetails)
            } finally {
              this.addressLookupLoading = false
            }
          }
        }
        if (this.modelObj.vat) this.verfifyVat()
        this.checkIfOrgNumberExists()
      } else this.checkIfOrgNumberExists()
    },
    // Ids the API hands out for hits that came from brreg, see BrregServices.ContactIdPrefix
    isBrregContact (contact) {
      return !!contact && typeof contact.id === 'string' && contact.id.indexOf('BRREG-') === 0
    },
    // Fill phone, mail and homepage from a lookup hit. Only values the register actually has are written,
    // so a blank in the register never wipes a field that is already filled in.
    fillContactDetailsFromLookup (contact) {
      if (!contact) return
      const contactPoints = contact.contactpoints || []
      const firstValueOf = (types) => {
        for (let i = 0; i < types.length; i++) {
          const match = contactPoints.find(x => x.type === types[i] && x.value)
          if (match) return match.value
        }
        return ''
      }
      const model = {}
      // brreg writes the numbers grouped with spaces, 1881 does not, store them the same way
      const phone = firstValueOf(['Phone', 'MobilePhone'])
      if (phone) model.telephone1 = phone.replace(/\s/g, '')
      const email = firstValueOf(['Email'])
      if (email) {
        model.email = email
        model.invoiceemail = email
      }
      // The 1881 infourl is a profile page on 1881.no, only brreg gives the company homepage
      if (contact.infourl && this.isBrregContact(contact)) model.homepage = contact.infourl
      if (Object.keys(model).length === 0) return
      this.modelObj = Object.assign({ ...this.modelObj }, model)
      if (model.telephone1) this.countrySelected()
    },
    checkIfOrgNumberExists () {
      this.changesMade()
      this.isCustomerExists = false
      if (this.modelObj.name) {
        const query = { filter: `id ne '${this.modelObj.id || 0}' AND name eq '${this.modelObj.name}'` }
        this.$_executeApi('post', 'customers/query', query)
          .then(response => {
            const getCustomers = response.data
            this.isCustomerExists = getCustomers.length > 0
          })
      }
    },
    // True while the user is still typing an organization number, digits and separators only with less than 9 digits
    isPartialOrganizationNumber (val) {
      if (!/^[\d\s.-]+$/.test(val)) return false
      return val.replace(/\D/g, '').length < 9
    },
    // Search from company API
    loadCompanyData () {
      this.getContactByContactName()
      // this.$_executeApi('get', 'https://data.brreg.no/enhetsregisteret/api/enheter?navn=' + encodeURIComponent(this.search), { headers: '' }).then(response => {
      //   this.items = response.data && response.data._embedded ? response.data._embedded.enheter : ''
      //   this.companyArray = []
      //   if (this.items) {
      //     for (let i = 0; i < this.items.length; i++) {
      //       this.companyArray.push(this.items[i].navn)
      //     }
      //   }
      // }).finally(() => {
      //   this.isLoading = false
      // })
    },
    customerChanged () {
      this.modelObj.issupplier = false
      if (this.modelObj.iscustomer) this.modelObj.state = 2
      else if (this.modelObj.issupplier) this.modelObj.state = 3
      this.changesMade()
    },
    supplierChanged () {
      this.modelObj.iscustomer = false
      if (this.modelObj.issupplier) this.modelObj.state = 3
      else if (this.modelObj.iscustomer) this.modelObj.state = 2
      this.changesMade()
    },
    isValidHttpUrl (string) {
      let url
      try {
        url = new URL(string)
      } catch (_) {
        return false
      }
      return url.protocol === 'http:' || url.protocol === 'https:'
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.crmReference.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    },
    exportPriceList () {
      this.exporting = true
      this.$_executeApi('post', `products/export_for_customer/${this.modelObj.id}`)
        .then((response) => {
          let fileName = response.data
          this.exporting = false
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
    },
    checkForDuplicates () {
      const result = this.contacts1881LookUpClone.find(x => x.isSelected && x.namealreadyexists)
      if (result) {
        this.duplicateNameDialog = true
      } else {
        this.saveBulkCustomersHandler()
      }
    },
    countrySelected () {
      if (!this.modelObj.phone_dialcode) this.modelObj.phone_dialcode = '+47'
      const countryObj = this.countries.find(x => x.dialCode === this.modelObj.phone_dialcode)
      if (countryObj != null) this.modelObj.phone_dialcode_flag = countryObj.flag
    },
    saveBulkCustomersHandler () {
      const customerModel = []
      this.loading = true
      const selectedContacts = this.contacts1881LookUpClone.filter(x => x.isSelected)
      selectedContacts.map((customer) => {
        customer.id = 0
        // add addreses
        const customeraddresses = []
        const physicalAddress = {}
        physicalAddress.customer_id = customer.id
        physicalAddress.type = 'invoice'
        if (customer.geography) {
          physicalAddress.municipality = customer.geography.municipality
        }
        if (customer.geography.address) {
          physicalAddress.address = customer.geography.address.street
          physicalAddress.address += `${physicalAddress.address ? ' ' : ''}${customer.geography.address.housenumber}`
          physicalAddress.city = customer.geography.address.postarea
          physicalAddress.postcode = customer.geography.address.postcode
          physicalAddress.country = customer.geography.county || ''
        }
        customeraddresses.push(physicalAddress)
        const postalAddress = {}
        if (customer.legalinformation && customer.legalinformation.postaddress) {
          postalAddress.customer_id = customer.id
          postalAddress.type = 'post'
          postalAddress.postcode = customer.legalinformation.postaddress.postcode
          postalAddress.municipality = customer.legalinformation.postaddress.postarea
          postalAddress.city = customer.legalinformation.postaddress.postarea
          postalAddress.address = `${customer.legalinformation.postaddress.prefix ? customer.legalinformation.postaddress.prefix : ''} ${customer.legalinformation.postaddress.number ? customer.legalinformation.postaddress.number : ''}`
          postalAddress.address += `${postalAddress.address ? ', ' : ''}${customer.legalinformation.postaddress.text}`
          customeraddresses.push(postalAddress)
        }
        if (this.contacts1881LookUpClone && this.contacts1881LookUpClone.length > 0) {
          if (customeraddresses && customeraddresses.length > 0) {
            customeraddresses[0].isdefault = true
            customer.address = customeraddresses[0].address
            customer.postcode = customeraddresses[0].postcode
            customer.city = customeraddresses[0].city
          }
        }
        customerModel.push({ customer, customeraddresses })
      })
      this.$_executeApi('post', 'customers/bulksave_for_1881lookup', customerModel)
        .then(({ data }) => {
          this.$store.commit('isChangesMade', false)
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.addedSucess') })
          this.showLookupDialog = false
          this.disableLookupButton = false
          if (data.length === 1 && data[0].customer && data[0].customer.id) {
            if (this.$route.path === '/customers/actions') this.$router.push(`/customers/edit/${data[0].customer.id}/view`)
          } else {
            this.$router.push('/customers')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    checkAllIsTrue (index) {
      if (index >= 0) {
        this.contacts1881LookUpClone[index].isSelected = this.listOfContactsFromlookup[index].includes
        this.contacts1881LookUpClone[index].paymentterm = 14
        this.contacts1881LookUpClone[index].isactive = true
        this.contacts1881LookUpClone[index].iscustomer = true
        this.contacts1881LookUpClone[index].location = 'norwegian'
        this.contacts1881LookUpClone[index].language = 'no'
        this.contacts1881LookUpClone[index].paymentmethod1 = 'direct'
        this.contacts1881LookUpClone[index].vatid = 25
        this.contacts1881LookUpClone[index].state = 2
        this.contacts1881LookUpClone[index].invoicecurrencyid = 3
        if (this.contacts1881LookUpClone[index].phoneContacts && this.contacts1881LookUpClone[index].phoneContacts.length === 1) {
          this.$set(this.contacts1881LookUpClone, index, {
            ...this.contacts1881LookUpClone[index],
            telephone1: this.contacts1881LookUpClone[index].phoneContacts[0].value
          })
        }
        if (this.contacts1881LookUpClone[index].emailContacts && this.contacts1881LookUpClone[index].emailContacts.length === 1) {
          this.$set(this.contacts1881LookUpClone, index, {
            ...this.contacts1881LookUpClone[index],
            email: this.contacts1881LookUpClone[index].emailContacts[0].value,
            invoice_email: this.contacts1881LookUpClone[index].emailContacts[0].value
          })
        }
      }
      return !this.listOfContactsFromlookup.some((contact) => contact.includes)
    },
    getContactByPhone () {
      if (this.modelObj.telephone1) {
        this.disableLookupButton = true
        this.$_executeApi('get', `api1881lookup/get_contacts/${this.modelObj.telephone1}`).then(({ data }) => {
          this.listOfContactsFromlookup = data
          this.contacts1881LookUpClone = this.$formatter.cloneVariable(data)
          this.contacts1881LookUpClone.map((x) => {
            x.web = x.infourl
            x.active = true
            x.is_customer = true
            x.customer_type = x.type === 'Person' ? 1 : 2
            x.vat = x.organizationnumber
            x.phoneContacts = x.contactpoints.filter(x => x.type === 'Phone')
            x.emailContacts = x.contactpoints.filter(x => x.type === 'Email')
            x.phoneContacts = x.phoneContacts.length === 0 ? [{ type: 'Phone', value: this.modelObj.telephone1 }] : x.phoneContacts
          })
          this.showLookupDialog = true
        })
      }
    },
    getContactByContactName () {
      if (this.search) {
        this.$_executeApi('get', `api1881lookup/get_contacts_by_name/${encodeURIComponent(this.search)}`).then(({ data }) => {
          this.contacts1881DetailedList = data
          this.companyArray = []
          if (this.contacts1881DetailedList) {
            for (let i = 0; i < this.contacts1881DetailedList.length; i++) {
              const name = this.contacts1881DetailedList[i].name
              const number = this.contacts1881DetailedList[i].organizationnumber
              this.companyArray.push({ value: this.contacts1881DetailedList[i].name, valuewithOrg: `${name} ${number ? `(${number})` : ''}` })
            }
          }
        }).finally(() => {
          this.isLoading = false
        })
      }
    },
    // Get address from 1881 lookup by id from 1881 contacts result!
    getAddressFrom1881 (id) {
      if (id) {
        return this.$_executeApi('get', `api1881lookup/get_address_by_contactid/${id}`)
      } else {
        return Promise.resolve({ data: false })
      }
    },
    saveCustomerAddress (model) {
      return this.$_executeApi('post', 'customeraddresses', model)
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('setItemInField')
  }
}
</script>
